export const ARC_TEMPLATE_PRESETS = [
  {
    id: "arc_level1_full",
    title: "NRA ARC Level 1",
    summary: "Official four-stage Level 1 course.",
    competitionType: "nra_arc",
    level: "NRA ARC Level 1",
    sanctionedType: "nra_arc",
    defaultName: "NRA ARC Level 1 Match",
    structureSourceKind: "match_template",
    squadDefaults: {
      squadCount: "4",
      squadIntervalMinutes: "30",
      maxCompetitorsPerSquad: "20"
    },
    stageVariantNote: "Preset stage shells are attached at creation.",
    stages: [
      { stageId: "preset.arc.l1.stage1", id: "preset.arc.l1.stage1", number: 1, name: "NRA ARC L1 - Stage 1 (Fundamentals)" },
      { stageId: "preset.arc.l1.stage2", id: "preset.arc.l1.stage2", number: 2, name: "NRA ARC L1 - Stage 2 (Positional / Precision)" },
      { stageId: "preset.arc.l1.stage3", id: "preset.arc.l1.stage3", number: 3, name: "NRA ARC L1 - Stage 3 (Movement Test)" },
      { stageId: "preset.arc.l1.stage4", id: "preset.arc.l1.stage4", number: 4, name: "NRA ARC L1 - Stage 4 (Speed & Accuracy)" }
    ]
  },
  {
    id: "arc_level1_reduced_25yd",
    title: "NRA ARC Level 1 Reduced 25yd",
    summary: "Recommended reduced-range Level 1 course with the official reduced ordering.",
    competitionType: "nra_arc",
    level: "NRA ARC Level 1",
    sanctionedType: "nra_arc",
    defaultName: "NRA ARC Level 1 Reduced 25yd Match",
    structureSourceKind: "match_template",
    squadDefaults: {
      squadCount: "4",
      squadIntervalMinutes: "30",
      maxCompetitorsPerSquad: "20"
    },
    stageVariantNote: "Preset reduced stage shells are attached at creation.",
    stages: [
      { stageId: "preset.arc.l1.reduced.stage1", id: "preset.arc.l1.reduced.stage1", number: 1, name: "NRA ARC L1 Reduced - Stage 1 (Fundamentals)" },
      { stageId: "preset.arc.l1.reduced.stage3", id: "preset.arc.l1.reduced.stage3", number: 3, name: "NRA ARC L1 Reduced - Stage 3 (Movement Test)" },
      { stageId: "preset.arc.l1.reduced.stage2", id: "preset.arc.l1.reduced.stage2", number: 2, name: "NRA ARC L1 Reduced - Stage 2 (25yd Simulated Distances)" },
      { stageId: "preset.arc.l1.reduced.stage4", id: "preset.arc.l1.reduced.stage4", number: 4, name: "NRA ARC L1 Reduced - Stage 4 (25yd Simulated Steel)" }
    ]
  }
];

export const ARC_LEVEL_OPTIONS = [
  {
    value: "NRA ARC Level 1",
    label: "NRA ARC Level 1",
    supportsTemplate: true,
    defaultName: "NRA ARC Level 1 Match",
    squadDefaults: {
      squadCount: "4",
      squadIntervalMinutes: "30",
      maxCompetitorsPerSquad: "20"
    }
  },
  {
    value: "NRA ARC Level 2",
    label: "NRA ARC Level 2",
    supportsTemplate: false,
    defaultName: "NRA ARC Level 2 Match",
    squadDefaults: {
      squadCount: "6",
      squadIntervalMinutes: "20",
      maxCompetitorsPerSquad: "20"
    }
  },
  {
    value: "NRA ARC 2 Gun",
    label: "NRA ARC 2 Gun",
    supportsTemplate: false,
    defaultName: "NRA ARC 2 Gun Match",
    squadDefaults: {
      squadCount: "6",
      squadIntervalMinutes: "20",
      maxCompetitorsPerSquad: "20"
    }
  }
];

export const BULLSEYE_FIREARM_OPTIONS = [
  { value: "rimfire", label: "Rimfire", mask: 1, discipline: "rimfire" },
  { value: "centerfire", label: "Centerfire", mask: 2, discipline: "centerfire" },
  { value: "fortyFive", label: ".45 Caliber", mask: 4, discipline: "fortyFive" }
];

export const BULLSEYE_SIGHT_OPTIONS = [
  ["program_defined", "Follow Match Program"],
  ["metallic_only", "Metallic Only"],
  ["anySights", "Any Sights"]
];

export const BULLSEYE_GENERATION_MODES = [
  {
    value: "single_selectable_firearm",
    label: "Single Firearm",
    summary: "Create one firearm group from a single firearm choice."
  },
  {
    value: "multiple_selectable_firearms",
    label: "Multiple Firearms",
    summary: "Reuse the shell for several firearm groups in one match."
  },
  {
    value: "fixed_three_gun_aggregate",
    label: "Three-Gun Aggregate",
    summary: "Generate rimfire, centerfire, and .45 phases."
  },
  {
    value: "fixed_three_phase_rimfire",
    label: "Three .22 Phases",
    summary: "Generate three separate rimfire phases."
  }
];

export const USPSA_TEMPLATE_PRESETS = [
  {
    id: "uspsa_club_match",
    title: "USPSA Club Match",
    summary: "General club match shell with practical stages.",
    ruleFamily: "competition",
    defaultName: "USPSA Club Match",
    level: "Level I",
    templateKind: "clubMatch",
    matchGenerationMode: "template_defined",
    stages: [
      { id: "preset.uspsa.club.stage1", stageId: "preset.uspsa.club.stage1", name: "Stage 1", number: 1 },
      { id: "preset.uspsa.club.stage2", stageId: "preset.uspsa.club.stage2", name: "Stage 2", number: 2 },
      { id: "preset.uspsa.club.stage3", stageId: "preset.uspsa.club.stage3", name: "Stage 3", number: 3 }
    ]
  },
  {
    id: "uspsa_classifier_match",
    title: "USPSA Classifier Match",
    summary: "Classifier-focused shell with standards-style stages.",
    ruleFamily: "competition",
    defaultName: "USPSA Classifier Match",
    level: "Level I",
    templateKind: "classifierMatch",
    matchGenerationMode: "template_defined",
    stages: [
      { id: "preset.uspsa.classifier.stage1", stageId: "preset.uspsa.classifier.stage1", name: "Classifier Stage 1", number: 1 },
      { id: "preset.uspsa.classifier.stage2", stageId: "preset.uspsa.classifier.stage2", name: "Classifier Stage 2", number: 2 }
    ]
  },
  {
    id: "uspsa_standards_match",
    title: "USPSA Standards Match",
    summary: "Standards-oriented shell for structured courses of fire.",
    ruleFamily: "competition",
    defaultName: "USPSA Standards Match",
    level: "Level II",
    templateKind: "standardsMatch",
    matchGenerationMode: "template_defined",
    stages: [
      { id: "preset.uspsa.standards.stage1", stageId: "preset.uspsa.standards.stage1", name: "Standards Stage 1", number: 1 },
      { id: "preset.uspsa.standards.stage2", stageId: "preset.uspsa.standards.stage2", name: "Standards Stage 2", number: 2 },
      { id: "preset.uspsa.standards.stage3", stageId: "preset.uspsa.standards.stage3", name: "Standards Stage 3", number: 3 }
    ]
  },
  {
    id: "scsa_club_match",
    title: "Steel Challenge Match",
    summary: "Steel Challenge club shell with four steel stages.",
    ruleFamily: "steel_challenge",
    defaultName: "Steel Challenge Match",
    level: "Level I",
    templateKind: "clubMatch",
    matchGenerationMode: "template_defined",
    stages: [
      { id: "preset.scsa.club.stage1", stageId: "preset.scsa.club.stage1", name: "Stage 1", number: 1 },
      { id: "preset.scsa.club.stage2", stageId: "preset.scsa.club.stage2", name: "Stage 2", number: 2 },
      { id: "preset.scsa.club.stage3", stageId: "preset.scsa.club.stage3", name: "Stage 3", number: 3 },
      { id: "preset.scsa.club.stage4", stageId: "preset.scsa.club.stage4", name: "Stage 4", number: 4 }
    ]
  },
  {
    id: "scsa_classifier_match",
    title: "Steel Challenge Classifier",
    summary: "Single-stage classifier shell for Steel Challenge.",
    ruleFamily: "steel_challenge",
    defaultName: "Steel Challenge Classifier",
    level: "Level I",
    templateKind: "classifierMatch",
    matchGenerationMode: "template_defined",
    stages: [
      { id: "preset.scsa.classifier.stage1", stageId: "preset.scsa.classifier.stage1", name: "Classifier Stage", number: 1 }
    ]
  }
];

export const USPSA_LEVEL_OPTIONS = [
  { value: "Level I", label: "Level I", defaultName: "USPSA Club Match" },
  { value: "Level II", label: "Level II", defaultName: "USPSA Level II Match" },
  { value: "Level III", label: "Level III", defaultName: "USPSA Level III Match" }
];

export const BULLSEYE_TEMPLATE_PRESETS = [
  {
    id: "bullseye_2700",
    title: "NRA Precision Pistol Championship 2700",
    summary: "Three 900-point firearm phases: Rimfire, Centerfire, and .45.",
    code: "nra_precision_pistol_championship_2700",
    name: "NRA Precision Pistol Championship 2700",
    selectedPistolDiscipline: "mixed",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "fixed_three_gun_aggregate",
    matchGenerationMode: "fixed_three_gun_aggregate",
    presetGunMask: 7,
    previewGroups: [
      { firearm: "Rimfire", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] },
      { firearm: "Centerfire", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] },
      { firearm: ".45", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_outdoor_900",
    title: "NRA Precision Pistol 900 (Outdoor)",
    summary: "Outdoor 900 with Slow Fire, National Match Course, Timed Fire, and Rapid Fire.",
    code: "nra_precision_pistol_900_outdoor",
    name: "NRA Precision Pistol 900 (Outdoor)",
    selectedPistolDiscipline: "mixed",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "selectable_single_firearm",
    matchGenerationMode: "single_selectable_firearm",
    previewGroups: [
      { firearm: "Selected Firearm", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_indoor_900",
    title: "NRA Precision Pistol 900 (Indoor .22 Gallery)",
    summary: "Indoor gallery 900 with Slow Fire, Gallery Course, Timed Fire, and Rapid Fire.",
    code: "nra_precision_pistol_900_indoor_gallery",
    name: "NRA Precision Pistol 900 (Indoor .22 Gallery)",
    selectedPistolDiscipline: "rimfire",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "fixed_template",
    matchGenerationMode: "template_defined",
    presetGunMask: 1,
    fixedFirearm: "rimfire",
    fixedFirearmLabel: "Rimfire",
    previewGroups: [
      { firearm: "Rimfire", courses: ["Slow Fire", "Gallery Course", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_nra_nmc",
    title: "NRA National Match Course",
    summary: "30-shot National Match Course with slow, timed, and rapid components.",
    code: "nra_national_match_course",
    name: "NRA National Match Course",
    selectedPistolDiscipline: "mixed",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "selectable_single_firearm",
    matchGenerationMode: "single_selectable_firearm",
    previewGroups: [
      { firearm: "Selected Firearm", courses: ["Slow Fire", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_cmp_rimfire_900",
    title: "CMP .22 Rimfire Pistol Match",
    summary: "CMP .22 rimfire 900 with a full National Match Course in the middle.",
    code: "cmp_22_rimfire_pistol_match",
    name: "CMP .22 Rimfire Pistol Match",
    selectedPistolDiscipline: "rimfire",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "fixed_template",
    matchGenerationMode: "template_defined",
    presetGunMask: 1,
    fixedFirearm: "rimfire",
    fixedFirearmLabel: "Rimfire",
    previewGroups: [
      { firearm: "Rimfire", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_cmp_centerfire_900",
    title: "CMP Centerfire Pistol Match",
    summary: "CMP centerfire 900 with a full National Match Course in the middle.",
    code: "cmp_centerfire_pistol_match",
    name: "CMP Centerfire Pistol Match",
    selectedPistolDiscipline: "centerfire",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "fixed_template",
    matchGenerationMode: "template_defined",
    presetGunMask: 2,
    fixedFirearm: "centerfire",
    fixedFirearmLabel: "Centerfire",
    previewGroups: [
      { firearm: "Centerfire", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_cmp_45_900",
    title: "CMP .45 Caliber Pistol Match",
    summary: "CMP .45 900 with a full National Match Course in the middle.",
    code: "cmp_45_caliber_pistol_match",
    name: "CMP .45 Caliber Pistol Match",
    selectedPistolDiscipline: "fortyFive",
    selectedSightMode: "program_defined",
    matchTemplateFirearmPolicy: "fixed_template",
    matchGenerationMode: "template_defined",
    presetGunMask: 4,
    fixedFirearm: "fortyFive",
    fixedFirearmLabel: ".45 Caliber",
    previewGroups: [
      { firearm: ".45", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] }
    ]
  },
  {
    id: "bullseye_cmp_service_pistol",
    title: "CMP Service Pistol Match",
    summary: "CMP service pistol 900. Optical sights are not permitted.",
    code: "cmp_service_pistol_match",
    name: "CMP Service Pistol Match",
    selectedPistolDiscipline: "servicePistol",
    selectedSightMode: "metallic_only",
    matchTemplateFirearmPolicy: "fixed_template",
    matchGenerationMode: "template_defined",
    fixedFirearmLabel: "Service Pistol",
    previewGroups: [
      { firearm: "Service Pistol", courses: ["Slow Fire", "National Match Course", "Timed Fire", "Rapid Fire"] }
    ]
  }
];

export function getArcPresetById(presetId) {
  return ARC_TEMPLATE_PRESETS.find((preset) => preset.id === presetId) || null;
}

export function getArcLevelOption(levelValue) {
  return ARC_LEVEL_OPTIONS.find((option) => option.value === levelValue) || ARC_LEVEL_OPTIONS[0];
}

export function getBullseyePresetById(presetId) {
  return BULLSEYE_TEMPLATE_PRESETS.find((preset) => preset.id === presetId) || null;
}

export function getBullseyeFirearmOption(value) {
  return BULLSEYE_FIREARM_OPTIONS.find((option) => option.value === value) || BULLSEYE_FIREARM_OPTIONS[0];
}

export function getBullseyeGenerationMode(value) {
  return BULLSEYE_GENERATION_MODES.find((mode) => mode.value === value) || BULLSEYE_GENERATION_MODES[0];
}

export function getUSPSAPresetById(presetId) {
  return USPSA_TEMPLATE_PRESETS.find((preset) => preset.id === presetId) || null;
}

export function getUSPSALevelOption(levelValue) {
  return USPSA_LEVEL_OPTIONS.find((option) => option.value === levelValue) || USPSA_LEVEL_OPTIONS[0];
}
